import clsx from 'clsx';
import { DatasourceStatus } from '@/utilities/datasources.utilities';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleMinus,
  faCircleQuestion,
  faTriangleExclamation,
} from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, LoadingIndicator } from '@seeqdev/qomponents';
import type { IconDefinition } from '@seeqdev/icons';
import type { IconType } from '@seeqdev/qomponents';

const statusIcons: Record<DatasourceStatus, { icon: IconDefinition | null; className: string }> = {
  [DatasourceStatus.Unknown]: { icon: faTriangleExclamation, className: 'sq-status-error' },
  [DatasourceStatus.New]: { icon: faCircleQuestion, className: 'sq-status-info' },
  [DatasourceStatus.Error]: { icon: faTriangleExclamation, className: 'sq-status-error' },
  [DatasourceStatus.Indexing]: { icon: null, className: 'sq-status-progress' },
  [DatasourceStatus.Warning]: { icon: faCircleExclamation, className: 'sq-status-warning' },
  [DatasourceStatus.Happy]: { icon: faCircleCheck, className: 'sq-status-good' },
  [DatasourceStatus.NotConnectable]: { icon: faCircleMinus, className: 'disabledLook' },
};

/** Datasource status displayed in administration cards and the footer popup. */
export const DatasourceStatusIcon = ({
  status,
  large,
  type,
  extraClassNames,
  testId,
}: {
  status: DatasourceStatus;
  large?: boolean;
  type?: IconType;
  extraClassNames?: string;
  testId?: string;
}) => {
  const { icon, className } = statusIcons[status];
  return icon ? (
    <Icon icon={icon} large={large} type={type} extraClassNames={clsx(className, extraClassNames)} testId={testId} />
  ) : (
    <LoadingIndicator size="sm" extraClassNames={className} testId={testId} />
  );
};
